import { render, staticRenderFns } from "./numbers-metrics-item.vue?vue&type=template&id=7d0c4456&"
import script from "./numbers-metrics-item.vue?vue&type=script&lang=js&"
export * from "./numbers-metrics-item.vue?vue&type=script&lang=js&"
import style0 from "./numbers-metrics-item.vue?vue&type=style&index=0&id=7d0c4456&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports